import React from "react";

const PopularTopicsSection = () => {
  const topics = [
    {
      title: "Energy Communities Day - who's coming?",
      author: "maxmu",
      date: "15. Oct 2023",
      replies: 7,
      excerpt:
        "I would like to go to Vienna on 27.02.2025 for Energy Communities Day. Since I had such great conversations with some of you here, I wanted to ask who is going too?",
      category: "Events",
    },
    {
      title: "Best practices for energy communities",
      author: "energyExpert",
      date: "12. Oct 2023",
      replies: 12,
      excerpt:
        "I've been working with energy communities for the past 5 years and wanted to share some best practices I've learned. First, clear governance structures are essential...",
      category: "Best Practices",
    },
    {
      title: "Funding opportunities for communities",
      author: "grantSeeker",
      date: "10. Oct 2023",
      replies: 5,
      excerpt:
        "Has anyone had success with applying for government grants for energy community projects? I'm looking at the new EU funding program but the application process seems complicated...",
      category: "Funding",
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800">
            Popular Discussions
          </h2>
          <a
            href="/beitrag-detail"
            className="text-rose-700 font-medium hover:text-rose-800 transition-colors"
          >
            View All Discussions →
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {topics.map((topic, index) => (
            <article
              key={index}
              className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow"
            >
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="text-xs font-medium text-white bg-rose-700 px-2 py-1 rounded-full">
                    {topic.category}
                  </span>
                  <span className="text-xs text-gray-500 ml-2">
                    {topic.date}
                  </span>
                </div>

                <h3 className="text-xl font-semibold text-gray-800 mb-2 line-clamp-2">
                  <a
                    href="/beitrag-detail"
                    className="hover:text-rose-700 transition-colors"
                  >
                    {topic.title}
                  </a>
                </h3>

                <p className="text-gray-600 mb-4 line-clamp-3">
                  {topic.excerpt}
                </p>

                <div className="flex justify-between items-center">
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center text-gray-700 font-medium">
                      {topic.author.charAt(0).toUpperCase()}
                    </div>
                    <span className="text-sm text-gray-700 ml-2">
                      {topic.author}
                    </span>
                  </div>

                  <div className="text-sm text-gray-500">
                    {topic.replies} {topic.replies === 1 ? "reply" : "replies"}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularTopicsSection;
